export const isPublicPath = (path) => {
    return path.split(('/'))[1] == "public";
}
